import { CmsContent, CmsKey } from '@dxp/data-access'
import { ValidationUtils } from '@dxp/utils'

import { cmsControlledError, FormFieldError } from './types/form-state'

export const getValidationErrors =
  ValidationUtils.getValidationErrors<FormFieldError>()

export const getErrorText = (
  error: FormFieldError | null | undefined,
  cms: CmsContent,
) => {
  if (typeof error === 'string') {
    return error.trim()
  }
  if (error?.cmsControlled) {
    return cms[error.cmsKey]
  }
}

export const defineCMSControlledValidationError = (
  cmsKey: CmsKey,
): cmsControlledError => ({
  cmsKey,
  cmsControlled: true,
})
